import React from "react";

import { FileUp, FileX2 } from "lucide-react";

import { SPONSOR_STEP } from "./flowCopy";

// The sponsor's three steps, in the step bar's words (F-UF-F21).
const STEPS_LINE = `${SPONSOR_STEP.sponsor}, ${SPONSOR_STEP.qa} and ${SPONSOR_STEP.viewer}`;

interface Props {
  /** The account's AE, who uploads the plan; null when none is on the team. */
  aeName: string | null;
  /** Shown only to someone who can upload (holds AE on the account). */
  onUpload?: () => void;
}

/**
 * The sponsor's layout with no plan behind it (never uploaded, or reset).
 * Briefing / Briefing Questions / View source would all be empty, so the page says what is
 * missing and who provides it instead of showing three empty steps.
 */
const NoPlanYet: React.FC<Props> = ({ aeName, onUpload }) => (
  <div className="rounded-xl border border-dashed border-gray-300 bg-white p-10 text-center">
    <FileX2 className="mx-auto mb-3 h-12 w-12 text-gray-300" aria-hidden />
    <h2 className="mb-1 text-lg font-semibold text-gray-700">
      No account plan yet
    </h2>
    <p className="mx-auto max-w-md text-sm text-gray-500">
      {onUpload
        ? `Upload the account plan to build ${STEPS_LINE} for this account.`
        : `${aeName || "The account executive"} uploads the account plan. ${STEPS_LINE} appear here once it's shared.`}
    </p>
    {onUpload && (
      <button
        type="button"
        onClick={onUpload}
        className="mt-5 inline-flex items-center gap-1.5 rounded-lg bg-[#974ae4] px-4 py-2 text-sm font-semibold text-white hover:bg-[#8538d4] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#974ae4]/50"
      >
        <FileUp className="h-4 w-4" aria-hidden /> Upload account plan
      </button>
    )}
  </div>
);

export default NoPlanYet;
